import { Card, Popconfirm } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { usePagination, useSortBy, useTable } from "react-table";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { getCompaniesWithEmployees } from "../../../../lib/getCompaniesWithEmployees";
import { getPendingCompanies } from "../../../../lib/getPendingCompanies";
import { updateUserCompanyStatus } from "../../../../lib/updateUserCompanyStatus";

const notifyTopRight = () => {
  toast.success("Se confirmó correctamente el registro.", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });
};

const notifyWarTopRight = () => {
  toast.warning("Se rechazó correctamente el registro", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });
};

const ManagementPanel = () => {
  const savedInStorage = JSON.parse(localStorage.getItem("userDetails"));
  let navigate = useNavigate();
  const [companiesWithEmployees, setCompaniesWithEmployee] = useState([]);
  const [pendingCompanies, setPendingCompanies] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);

  //TRAER EMPRESAS Y EMPLEADOS

  useEffect(() => {
    debugger
    if (
      savedInStorage.role !== "admin" &&
      companiesWithEmployees.length === 0
    ) {
      getCompaniesWithEmployees().then((res) => {
        console.log("companyDATAEmploye", res.data)

        if(res.data=='') res.data = [];
        setCompaniesWithEmployee(res.data);
      });

      getPendingCompanies().then((res) => {
        console.log("companyDATA", res.data)
        if(res.data==='') res.data = [];
        debugger
        setPendingCompanies(res.data);
      });
    } else {
      navigate("/dashboard");
    }
  }, []);

  //GET EMPRESAS Y REGISTROS CON STATUS PENDING

  const columnsPending = useMemo(
    () => [
      {
        Header: "Razon Social",
        accessor: "name",
      },
      {
        Header: "Dirección",
        accessor: "address",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Teléfono",
        accessor: "phoneNumber",
      },
      {
        Header: "CUIT",
        accessor: "cuit",
      },
      {
        Header: " ",
        disableSortBy: true,
        Cell: (props) => (
          <div className="d-flex justify-content-end">
            <Popconfirm
              placement="left"
              title={"Atención"}
              description={
                <h6>
                  ¿Desea <strong>confirmar</strong> que esta empresa quedé
                  registrada?
                </h6>
              }
              onConfirm={async () => {
                const { _id } = props.cell.row.original.users[0];
                await updateUserCompanyStatus({
                  idUser: _id,
                  status: "ACTIVE",
                }).then((res) => {
                  debugger
                  if (res.status === 200) {
                    notifyTopRight();
                    getCompaniesWithEmployees().then((res) => {
                      setCompaniesWithEmployee(res.data);
                    });

                    getPendingCompanies().then((res) => {
                      setPendingCompanies(res.data);
                    });
                  }
                });
              }}
              okText="Si"
              cancelText="No"
            >
              <Link
                to={"#"}
                className="btn btn-primary shadow btn-xs sharp"
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-check"></i>
              </Link>
            </Popconfirm>

            <Popconfirm
              placement="left"
              title={"Atención"}
              description={
                <h5>
                  ¿Desea <strong>rechazar</strong> este registro?
                </h5>
              }
              onConfirm={async () => {
                const { _id } = props.cell.row.original.users[0];
                await updateUserCompanyStatus({
                  idUser: _id,
                  status: "CANCELED",
                }).then((res) => {
                  if (res.status === 200) {
                    notifyWarTopRight();
                    getCompaniesWithEmployees().then((res) => {
                      setCompaniesWithEmployee(res.data);
                    });

                    getPendingCompanies().then((res) => {
                      setPendingCompanies(res.data);
                    });
                  }
                });
              }}
              okText="Si"
              cancelText="No"
            >
              <Link to={"#"} className="btn btn-danger shadow btn-xs sharp">
                <i className="fa fa-x"></i>
              </Link>
            </Popconfirm>
          </div>
        ),
      },
    ],
    []
  );

  const columnsEmpresa = useMemo(
    () => [
      {
        Header: "Razon Social",
        accessor: "name",
      },
      {
        Header: "Dirección",
        accessor: "address",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Teléfono",
        accessor: "phoneNumber",
      },
      {
        Header: "CUIT",
        accessor: "cuit",
      },
    ],
    []
  );

  const tableInstance1 = useTable(
    {
      columns: columnsEmpresa,
      data: companiesWithEmployees,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination
  );

  const tableInstance2 = useTable(
    {
      columns: columnsPending,
      data: pendingCompanies,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination
  );

  const {
    getTableProps: getTableProps1,
    getTableBodyProps: getTableBodyProps1,
    headerGroups: headerGroups1,
    rows: rows1,
    prepareRow: prepareRow1,
    nextPage: nextPage1,
    previousPage: previousPage1,
    canNextPage: canNextPage1,
    canPreviousPage: canPreviousPage1,
  } = tableInstance1;

  const {
    getTableProps: getTableProps2,
    getTableBodyProps: getTableBodyProps2,
    headerGroups: headerGroups2,
    rows: rows2,
    prepareRow: prepareRow2,
    nextPage: nextPage2,
    previousPage: previousPage2,
    canNextPage: canNextPage2,
    canPreviousPage: canPreviousPage2,
  } = tableInstance2;

  const toggleRowExpansion = (rowIndex) => {
    setExpandedRows((prevExpandedRows) => {
      const expandedRowsSet = new Set(prevExpandedRows);
      if (expandedRowsSet.has(rowIndex)) {
        expandedRowsSet.delete(rowIndex);
      } else {
        expandedRowsSet.add(rowIndex);
      }
      return Array.from(expandedRowsSet);
    });
  };

  return (
    <>
      {companiesWithEmployees && companiesWithEmployees.length > 0 && (
        <>
          <h3 className="cargaEMpleados">Empresas registradas </h3>
          <Card style={{ marginBottom: "10px" }}>
            <div className="table-responsive" style={{ maxHeight: "280px" }}>
              <div className="dataTables_wrapper">
                <table
                  {...getTableProps1()}
                  className="table dataTable display"
                >
                  <thead>
                    {headerGroups1.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => {
                          return (
                            <th {...column.getHeaderProps()}>
                              {column.render("Header")}
                              {column.Header === "Apellido y Nombre" && (
                                <span className="ml-1">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              )}
                            </th>
                          );
                        })}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps1()}>
                    {rows1.map((row, index) => {
                      prepareRow1(row);
                      const isExpanded = expandedRows.includes(index);
                      return (
                        <React.Fragment key={index}>
                          <tr
                            style={{ cursor: "pointer" }}
                            {...row.getRowProps()}
                            onClick={() => toggleRowExpansion(index)}
                          >
                            {row.cells.map((cell) => (
                              <td {...cell.getCellProps()}>
                                {cell.render("Cell")}
                              </td>
                            ))}
                          </tr>
                          {isExpanded && (
                            <td
                              colSpan={columnsPending.length}
                              style={{ border: "none" }}
                            >
                              <table>
                                <thead>
                                  <tr>
                                    <th>Apellido y Nombre</th>
                                    <th>DNI</th>
                                    <th>Email</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {row.original.employees.map(
                                    (employee, employeeIndex) => (
                                      <tr key={employeeIndex}>
                                        <td>{employee.name}</td>
                                        <td>{employee.dni}</td>
                                        <td>{employee.email}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </td>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </>
      )}

      
        <>
          <h3 className="cargaEMpleados">Registros entrantes </h3>
          <Card style={{ marginTop: "10px" }}>
            <div className="table-responsive" style={{ maxHeight: "280px" }}>
              <div className="dataTables_wrapper">
              {pendingCompanies && pendingCompanies.length > 0 && ( <table
                  {...getTableProps2()}
                  className="table dataTable display"
                >
                  <thead>
                    {headerGroups2.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => {
                          return (
                            <th {...column.getHeaderProps()}>
                              {column.render("Header")}
                              {column.Header === "Apellido y Nombre" && (
                                <span className="ml-1">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              )}
                            </th>
                          );
                        })}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {rows2.map((row) => {
                      prepareRow2(row);
                      return (
                        <tr>
                          {row.cells.map((cell) => {
                            return <td>{cell.render("Cell")} </td>;
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                 )}
                   {/* If there are no pending companies, show a message */}
                   {(!pendingCompanies || pendingCompanies.length === 0) && (
                    <p>No hay Empresas pendientes de Aprobación </p>
                   )}
              </div>
            </div>
          </Card>
        </>
     
      <ToastContainer />
    </>
  );
};

export default ManagementPanel;
